import { Router } from '@angular/router';
import { NotificacionService } from './notificacion';
import { Globals } from '@config/global';
import { Injectable } from '@angular/core';
import { environment } from '@enviroment/environment';

@Injectable({
  providedIn: 'root',
})

/**
 * Servicio utilitario para la gestión de la campaña "Días Azules".
 *
 * Esta clase determina si la campaña de Días Azules está activa según la fecha actual y la fecha de expiración.
 * - Si la campaña está activa, envía una notificación con los parámetros promocionales y retorna true.
 * - Si la campaña ha expirado, envía una notificación indicando que no aplica y retorna false.
 * - Marca el último día de la campaña si faltan 3 días o menos.
 *
 * Utiliza servicios globales y de notificación para informar al usuario y a otros componentes.
 *
 * Uso típico: inyectar en componentes y llamar a `isDayBlue()` para saber si mostrar la promoción.
 */
export class BlueDays {
  private env = environment;
  private type_structure: any = {
    BLUE_DAYS: 'blue_days',
    BONO: 'bono',
  };

  constructor(
    private router: Router,
    private globals_var: Globals,
    private notificacion_components: NotificacionService,
  ) {}

  isDayBlue(response_with_data: boolean = false): any {
    let date_today: any = new Date();
    let date_expired: any = new Date('2026-02-13T14:59:59');
    let router_path = this.router.url.split('?')[0];
    let router_visibilty = [
      '/pauta/remarketing/hoy-los-bancos-ofrecen',
      '/pauta/llamada/hoy-los-bancos-ofrecen',
      '/pauta/control/hoy-los-bancos-ofrecen',
      '/hoy-los-bancos-ofrecen',
      '/dias-azules',
      '/cdt-simulador',
      '/',
    ];

    if (date_today < date_expired) {
      let time_difference = date_expired.getTime() - date_today.getTime();
      let days_remaining = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
      let response: any;

      let notificacion_params_blue_days = {
        type: this.type_structure.BONO,
        terms: [90, 180, 360, 540, 720],
        term_promo: [720, 360],
        term_default: 720,
        rate_promo: 12.3,
        entity_name: this.globals_var.KOA,
        entity_id: this.globals_var.ID_KOA,
        amount: 250000,
        amount_minimum: 250000,
        date_expired: date_expired,
        range_months: 'periodo de 24 meses',
        last_day: false,
        applies_to_any_amount: false,
        og_image_blue_days:
          this.env.S3_STATIC_FILES + '/images/web/dias-azules/og_bluedays-koa-12.30-feb-19-26.webp',
        image_blue_days: 'images/web/dias-azules/bluedays-koa-12.30-feb-19-26.webp',
        image_blue_days_mobile: 'images/web/dias-azules/bluedays-koa-12.30-feb-19-26.webp',
        title: '¡Subió la tasa y <br class="d-none d-md-block"> y tú aún estás a tiempo!',
        description:
          'Aprovecha este aumento y asegura <br class="d-none d-md-block"> <b>la rentabilidad más alta</b> por mas tiempo',
        bg_linear:
          'radial-gradient(circle farthest-corner at 51.68% 52.67%, rgba(17, 98, 255, 1) 59.55%, rgba(17, 91, 246, 1) 61.77%, rgba(17, 54, 198, 1) 74.16%, rgba(17, 28, 164, 1) 85.11%, rgba(17, 12, 143, 1) 94.1%, rgba(17, 6, 135, 1) 100%)',
        ga_bluedays: 'ga_bluedays_cdtazo_12_coltefinanciera',
        /* bonus_blue_days: {
          type: 'porcentual',
          tag_name: 'DIAS_AZULES_PORCENTUAL_020',
          percentage: 0.2,
          label: '+0.20%',
          min_amount: 50000000,
          applies_to_any_term: true,
          terms_locked: [],
          start_at: new Date('2026-01-09T00:00:00'),
          end_at: new Date('2026-01-15T14:59:59'),
          terms_url: 'legal/bono/dias-azules',
          image_banner_publisher: 'images/web/ilustrations/regalo-con-bono.webp',
        }, */
      };

      if (days_remaining <= 3) {
        notificacion_params_blue_days.last_day = true;
      }

      response = response_with_data ? notificacion_params_blue_days : true;

      this.notificacion_components.sendNotificacion({
        api: 'send_information_blue_days_active',
        notificacion_params_blue_days,
      });
      return response;
    } else {
      this.notificacion_components.sendNotificacion({
        api: 'send_information_blue_days_false',
        router: this.router.url.replace(/\?.*$/, ''),
      });
      return false;
    }
  }
}
